(() => {
  if (window.__ceryMediaProtection) return;
  window.__ceryMediaProtection = true;

  const PROTECTED_SELECTOR = 'img, picture, video, svg, canvas';
  const MEDIA_BACKGROUND_SELECTOR = [
    '.tab-slideshow__slide',
    '.cg__media',
    '.cs__avatar',
    '.resource-card',
    '.product-media-container',
    '.card-gallery',
  ].join(',');

  function protectedMediaFrom(target) {
    if (!(target instanceof Element)) return null;

    const media = target.closest(PROTECTED_SELECTOR);
    if (media) return media;

    const backgroundMedia = target.closest(MEDIA_BACKGROUND_SELECTOR);
    if (!backgroundMedia) return null;

    const backgroundImage = window.getComputedStyle(backgroundMedia).backgroundImage;
    return backgroundImage && backgroundImage !== 'none' ? backgroundMedia : null;
  }

  function hardenMedia(media) {
    if (!(media instanceof Element)) return;

    media.setAttribute('draggable', 'false');

    if (media instanceof HTMLVideoElement) {
      media.setAttribute('controlsList', 'nodownload noremoteplayback');
      media.setAttribute('disablePictureInPicture', '');
      media.disablePictureInPicture = true;
    }
  }

  function hardenAllMedia(root = document) {
    root.querySelectorAll(PROTECTED_SELECTOR).forEach(hardenMedia);
  }

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (protectedMediaFrom(event.target)) event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (protectedMediaFrom(event.target)) event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'selectstart',
    (event) => {
      if (protectedMediaFrom(event.target)) event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener('DOMContentLoaded', () => hardenAllMedia());

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        hardenMedia(node);
        hardenAllMedia(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
